import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Text } from '../assets/styles';

export type IOptionObj = { id: string; label: string };
export type IOption = string | IOptionObj;

interface IProps {
  selectedVal: IOption[] | IOption | null;
  selCountry: (arg: IOption[] | string | null) => void;
  multiple?: boolean;
  showLabel?: boolean;
  freeSolo?: boolean;
  options: IOption[];
  disabled?: boolean;
}

const CommonSelect2 = ({
  selectedVal,
  options,
  selCountry,
  multiple = true,
  showLabel = true,
  freeSolo = false,
  disabled,
}: IProps) => {
  const doInputChange = (e: any) => {
    if (freeSolo) {
      selCountry(e?.target?.value || '');
    }
  };
  return (
    <>
      {showLabel && <Text $margin='0 8px 0 12px'>Country</Text>}
      <Autocomplete
        disabled={disabled}
        freeSolo={freeSolo}
        disablePortal
        multiple={multiple}
        value={!multiple && selectedVal === '' ? null : selectedVal}
        id='combo-box-demo'
        options={options}
        sx={{ width: 250 }}
        isOptionEqualToValue={(option, value) => {
          if (typeof option === 'string' && typeof value === 'string') {
            return option === value;
          }
          if (typeof option === 'object' && typeof value === 'object') {
            return option.id === value.id; // id로 동등성 비교
          }
          return false;
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') return option;
          return option?.label || ''; // 객체면 label 반환
        }}
        onChange={(e, newVal) => {
          if (typeof newVal === 'string') {
            selCountry(newVal);
          } else {
            // @ts-ignore
            selCountry(newVal);
          }
        }}
        onInputChange={doInputChange}
        renderInput={(params) => <TextField {...params} size='small' />}
      />
    </>
  );
};

export default CommonSelect2;
